/**
 * Created by mac on 7/15/20
 */

const PhotoViews = cc.Node.extend({
    ctor: function (gameScene) {
        this._super();
        this.differences = Game.currentGame;
        this.gameScene = gameScene;

        this.blurred = false;
        this.clovers = [];
        this.createImages();
        this.createClovers();

        this.photos = new cleverapps.Layout([this.imageA, this.imageB], this.getOptions());
        this.addChild(this.photos);

        this.differences.areas.forEach(function (area) {
            if (area.discovered) {
                const frameInfo = PhotoViews.FrameSizeAndPos(area);
                this.drawArea(this.imageA, frameInfo, true);
                this.drawArea(this.imageB, frameInfo, true);
            }
        }, this);

        this.createFrame();

        this.onResize();

        this.differences.on("mistake", this.mistake.bind(this));
        this.differences.on("discover", this.discover.bind(this));
        this.differences.on("paint", this.paint.bind(this));
        this.differences.on("complete", this.complete.bind(this));
        this.differences.on("booster_discover", this.boosterDiscover.bind(this));
        
        cleverapps.focusManager.registerControl("photos", this.createListener((visible, silent) => {
            this.toggleBlur(!visible, undefined, silent);
        }));

        if (cleverapps.config.debugMode) {
            const rate = cleverapps.UI.generateImageText(this.differences.level.content.rate, cleverapps.styles.FONTS.MENUBAR_TEXT);
            this.addChild(rate);
            rate.setAlignment(this.width / 2, this.height / 2);
        }
    },

    onResize: function () {
        const styles = cleverapps.styles.PhotoViews;
        this.photos.setOptions(this.getOptions());

        this.setContentSize(this.photos.getContentSize());
        const size = {
            width: this.width + styles.photoFrame.padding.x,
            height: this.height + styles.photoFrame.padding.y
        };
        this.frame.setContentSize(size);

        this.frame.setAlignment(this.width / 2 + styles.photoFrame.offset.x, this.height / 2 + styles.photoFrame.offset.y);
        this.photos.setAlignment(this.width / 2, this.height / 2);
        this.completeAnimation && this.completeAnimation.setAlignment(this.width / 2, this.height / 2);
    },

    getPhotoSize: function () {
        return this.imageA.getContentSize();
    },

    getOptions: function () {
        return {
            direction: cleverapps.resolution.mode !== cleverapps.WideMode.VERTICAL ? cleverapps.UI.HORIZONTAL : cleverapps.UI.VERTICAL,
            margin: cleverapps.styles.PhotoViews.margin
        };
    },

    onClick: function (imgId, point) {
        if (this.blurred
            || cleverapps.focusManager.isFocused()
            && !(cleverapps.tutorial.isActive() && cleverapps.tutorial.getActive().name === TutorialScenario.BASIC_TUTORIAL_NAME)) {
            return;
        }
       
        this.differences.clickPoint(imgId, point);
    },

    createImages: function () {
        this.imageA = new cc.Sprite(this.differences.getImage("a"));
        cleverapps.UI.onClick(this.imageA, (touch) => {
            const point = this.imageA.convertTouchToNodeSpace(touch);
            this.onClick("a", point);
        }, {
            interactiveScale: false
        });

        this.imageB = new cc.Sprite(this.differences.getImage("b"));
        cleverapps.UI.onClick(this.imageB, (touch) => {
            const point = this.imageB.convertTouchToNodeSpace(touch);
            this.onClick("b", point);
        }, {
            interactiveScale: false
        });

        [this.imageA, this.imageB].forEach((image) => {
            image.clickAnimation = new cleverapps.Spine(bundles.game.jsons.click_json);
            image.addChild(image.clickAnimation);
        });
    },

    createClovers: function () {
        if (!Game.currentGame.lightingRushMission) {
            return;
        }

        this.differences.clovers.forEach((cloverData) => {
            this.clovers.push(new PhotoClover(cloverData, this));
        });
    },

    createFrame: function () {
        const frame = this.frame = cleverapps.UI.createScale9Sprite(bundles.game.frames.photo_frame, cleverapps.UI.Scale9Rect.TwoPixelXY);
        frame.setLocalZOrder(-1);
        this.addChild(frame);
    },

    paint: function () {
        new PaintBrush(this);
    },

    discover: function (area, imgId, point, cb) {
        cleverapps.effects.fire("differences.area.found");

        const image = imgId === "a" ? this.imageA : this.imageB;
        if (point) {
            image.clickAnimation.setAlignment(point);
            image.clickAnimation.setAnimation(0, "animation", false);
        }

        const frameInfo = PhotoViews.FrameSizeAndPos(area);

        if (cb) {
            this.runAction(new cc.Sequence(
                new cc.DelayTime(0.5),
                new cc.CallFunc(cb)
            ));
        }

        [this.imageA, this.imageB].forEach(function (parent) {
            const target = cleverapps.aims.getTarget("user_progress");

            const startPos = this.gameScene.convertToNodeSpace(parent.convertToWorldSpace(PhotoViews.FrameSizeAndPos(area)));
            const targetPos = this.gameScene.convertToNodeSpace(target.parent.convertToWorldSpace(target.getPosition()));
            const scorePoint = new ScoreRocket(startPos, targetPos);
            this.gameScene.addChild(scorePoint);

            this.drawArea(parent, frameInfo);
        }, this);
    },

    drawArea: function (parent, frameInfo, silent) {
        const frame = cleverapps.UI.createScale9Sprite(bundles.game.frames.found_area);
        parent.addChild(frame, 1);

        frame.setContentSize2(frameInfo);
        frame.setAlignment(frameInfo);

        if (silent) {
            return;
        }

        frame.setScale(0.2);
        frame.setOpacity(0);

        const time = 0.4;
        frame.runAction(new cc.Spawn(
            new cc.FadeIn(time),
            new cc.ScaleTo(time, 1).easing(cc.easeBackOut())
        ));
    },

    mistake: function (image, point) {
        cleverapps.effects.fire("differences.guess.wrong");

        const animation = new cleverapps.Spine(bundles.game.jsons.mistake_json);
        animation.setAnimation(0, "animation", false);
        animation.setCompleteListenerRemove();

        (image === "a" ? this.imageA : this.imageB).addChild(animation);

        animation.setAlignment(point);
    },

    complete: function () {
        this.runAction(StandartAnimations.complete(this, { pulse: false }));
        cleverapps.focusManager.hideControlsWhileFocused("photos");

        cleverapps.effects.fire("differences.victory.mark");
    },

    hide: function () {
        this.runAction(new cc.Sequence(
            new cc.ScaleTo(0.4, 0.2).easing(cc.easeBackIn()),
            new cc.Hide()
        ));
    },

    boosterDiscover: function (options) {
        options = options || {};

        const button = cleverapps.Scenes.GetSceneComponent(DifferencesSceneComponent).discoverButton;
        const area = options.area;
        let startPos = options.startPos;

        cleverapps.effects.fire("differences.booster.discovery");

        [this.imageA, this.imageB].forEach((image) => {
            startPos = startPos || this.gameScene.convertToNodeSpace(button.parent.convertToWorldSpace(button.getPosition()));
            const targetPos = this.gameScene.convertToNodeSpace(image.convertToWorldSpace(PhotoViews.FrameSizeAndPos(area)));

            const rocket = new DiscoverRocket(startPos, targetPos, area, options.finger);
            this.gameScene.addChild(rocket);
        });
    },

    toggleClovers: function () {
        this.clovers.forEach((clover) => {
            clover.runAction(new cc.FadeTo(0.1, this.blurred ? 0 : clover.baseOpacity));
        });
    },

    isCloversForceAvailable: function () {
        if (this.clovers.length === 0 || this.blurred) {
            return false;
        }
        return cleverapps.forces.isAvailable(this, Forces.PHOTO_CLOVER);
    },

    showCloversForce: function () {
        const forceTarget = this.clovers[0];

        cleverapps.focusManager.displayWhenFreeFocus({
            focus: "PhotoCloverForce",
            control: ["rewardElementClover", "photos"],
            actions: [
                function (f) {
                    cleverapps.forces.create(forceTarget, Forces.PHOTO_CLOVER);
                    cleverapps.forces.onceForceClosed = f;
                }
            ]
        });
    },

    toggleBlur: function (blurred, callback, silent) {
        callback = callback || function () {};

        if (cleverapps.Scenes.GetSceneComponent(DifferencesSceneComponent).coolDownNodeActive() || this.blurred === blurred) {
            callback();
            return;
        }

        this.blurred = blurred;
        this.toggleClovers();

        const time = silent ? 0 : 0.3;

        [this.imageA, this.imageB].forEach((image, ind) => {
            cleverapps.UI.toggleBlur(image, {
                animate: {
                    type: cleverapps.UI.BLUR_ANIMATION.CURTAIN,
                    time,
                    steps: 30,
                    reverseCurtain: 1 - ind,
                    callback: function () {
                        if (ind === 1) {
                            callback();
                        }
                    }
                }
            });
        });
    }
});

PhotoViews.FrameSizeAndPos = function (area) {
    const size = cc.size(area.width * resolutionScale, area.height * resolutionScale);
    const pos = cc.p(area.x * resolutionScale, area.y * resolutionScale);

    return {
        width: size.width,
        height: size.height,
        x: pos.x,
        y: pos.y
    };
};

cleverapps.styles.PhotoViews = {
    margin: 20,

    photoFrame: {
        offset: {
            x: 0,
            y: -17
        },
        padding: {
            x: 50,
            y: 79
        }
    }
};
